module.exports = __webpack_public_path__ + "assets/3561e6913153032f30f0b8fdc45a9b40.png";